{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Vælg venligst en samtale fra venstre rude",
    "CSAT_REPLY_MESSAGE": "Bedøm venligst samtalen",
    "404": "Beklager, vi kan ikke finde samtalen. Prøv igen",
    "SWITCH_VIEW_LAYOUT": "Skift layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Beskeder",
    "UNVERIFIED_SESSION": "Identiteten af denne bruger er ikke bekræftet",
    "NO_MESSAGE_1": "Åh oh! Det ser ud til, at der ikke er nogen beskeder fra kunder i din indbakke.",
    "NO_MESSAGE_2": " for at sende en besked til din side!",
    "NO_INBOX_1": "Hola! Det ser ud til, at du endnu ikke har tilføjet indbakker.",
    "NO_INBOX_2": " for at komme i gang",
    "NO_INBOX_AGENT": "Åh Åh! Det ser ud til, at du ikke er en del af en indbakke. Kontakt venligst din administrator",
    "SEARCH_MESSAGES": "Søg efter beskeder i samtaler",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Søg efter beskeder",
      "RESULT_TITLE": "Søgeresultater",
      "LOADING_MESSAGE": "Behandler data...",
      "PLACEHOLDER": "Skriv tekst for at søge i beskeder",
      "NO_MATCHING_RESULTS": "Ingen resultater fundet."
    },
    "UNREAD_MESSAGES": "Ulæste Beskeder",
    "UNREAD_MESSAGE": "Ulæst Besked",
    "CLICK_HERE": "Klik her",
    "LOADING_INBOXES": "Indlæser indbakker",
    "LOADING_CONVERSATIONS": "Indlæser Samtaler",
    "CANNOT_REPLY": "Du kan ikke svare på grund af",
    "24_HOURS_WINDOW": "24 timers beskedvindue begrænsning",
    "48_HOURS_WINDOW": "48 timers beskedvindue begrænsning",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "Denne samtale er ikke tildelt dig. Vil du tildele denne samtale til dig selv?",
    "ASSIGN_TO_ME": "Tildel til mig",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "Du kan kun svare på denne samtale ved hjælp af en skabelon besked på grund af",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 timers beskedvindue begrænsning",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "INSTAGRAM_RESTRICTION_BANNER": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
    "INSTAGRAM_RESTRICTION_STATUS_LINK": "View status update",
    "REPLYING_TO": "Du svarer til:",
    "REMOVE_SELECTION": "Fjern Markering",
    "DOWNLOAD": "Download",
    "UNKNOWN_FILE_TYPE": "Ukendt Fil",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "{sender} has started a meeting"
    },
    "UPLOADING_ATTACHMENTS": "Uploader vedhæftede filer...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "Besked slettet",
    "FAIL_DELETE_MESSSAGE": "Kunne ikke slette beskeden! Prøv igen",
    "NO_RESPONSE": "Intet svar",
    "RESPONSE": "Response",
    "RATING_TITLE": "Bedømmelse",
    "FEEDBACK_TITLE": "Tilbagemelding",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Vis etiketter",
      "HIDE_LABELS": "Skjul etiketter",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Løs",
      "REOPEN_ACTION": "Genåben",
      "OPEN_ACTION": "Åbn",
      "MORE_ACTIONS": "More actions",
      "OPEN": "Mere",
      "CLOSE": "Luk",
      "DETAILS": "detaljer",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Udsat til i morgen",
      "SNOOZED_UNTIL_NEXT_WEEK": "Udsat indtil næste uge",
      "SNOOZED_UNTIL_NEXT_REPLY": "Udsat indtil næste svar",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Markér som afventende",
      "SNOOZE_UNTIL": "Udsæt",
      "SNOOZE": {
        "TITLE": "Udsæt til",
        "NEXT_REPLY": "Næste svar",
        "TOMORROW": "I Morgen",
        "NEXT_WEEK": "Næste uge"
      }
    },
    "MENTION": {
      "AGENTS": "Agenter",
      "TEAMS": "Teams"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Udsæt til",
      "APPLY": "Udsæt",
      "CANCEL": "Annuller"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Ingen",
        "URGENT": "Urgent",
        "HIGH": "High",
        "MEDIUM": "Medium",
        "LOW": "Low"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Ingen",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Ingen resultater fundet",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "Slet"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "Markér som afventende",
      "RESOLVED": "Marker som løst",
      "MARK_AS_UNREAD": "Marker som ulæst",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Genåbn samtale",
      "SNOOZE": {
        "TITLE": "Udsæt",
        "NEXT_REPLY": "Indtil næste svar",
        "TOMORROW": "Indtil i morgen",
        "NEXT_WEEK": "Indtil næste uge"
      },
      "ASSIGN_AGENT": "Tildel agent",
      "ASSIGN_LABEL": "Tildel etiket",
      "AGENTS_LOADING": "Indlæser agenter...",
      "ASSIGN_TEAM": "Tildel team",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Samtale id {conversationId} tildelt \"{agentName}\"",
          "FAILED": "Kunne ikke tildele agent. Prøv venligst igen."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Kunne ikke tildele etiket. Prøv venligst igen."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Tildelt team \"{team}\" til samtale-id {conversationId}",
          "FAILED": "Kunne ikke tildele team. Prøv venligst igen."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Besked signatur",
      "ENABLE_SIGN_TOOLTIP": "Aktiver signatur",
      "DISABLE_SIGN_TOOLTIP": "Deaktivér signatur",
      "MSG_INPUT": "Shift + enter for ny linje. Start med '/' for at vælge et standardsvar.",
      "PRIVATE_MSG_INPUT": "Shift + enter for ny linje. Dette vil kun være synligt for Agenter",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Beskedsignatur er ikke konfigureret, konfigurer den i profilindstillinger.",
      "COPILOT_MSG_INPUT": "Giv copilot yderligere prompts, eller spørg om noget andet... Tryk enter for at sende opfølgning",
      "CLICK_HERE": "Klik her for at opdatere",
      "WHATSAPP_TEMPLATES": "Whatsapp Skabeloner"
    },
    "REPLYBOX": {
      "REPLY": "Svar",
      "PRIVATE_NOTE": "Privat Note",
      "SEND": "Send",
      "CREATE": "Tilføj Note",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_EMOJI_ICON": "Vis emoji-vælger",
      "TIP_ATTACH_ICON": "Vedhæft filer",
      "TIP_AUDIORECORDER_ICON": "Optag lyd",
      "TIP_AUDIORECORDER_PERMISSION": "Tillad adgang til lyd",
      "TIP_AUDIORECORDER_ERROR": "Kunne ikke åbne lyden",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "Træk og slip her for at vedhæfte",
      "IMAGE_UPLOAD_SUCCESS": "Billede blev uploadet",
      "START_AUDIO_RECORDING": "Start lydoptagelse",
      "STOP_AUDIO_RECORDING": "Stop lydoptagelse",
      "COPILOT_THINKING": "Copilot tænker",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Tilføj bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-mails adskilt af kommaer",
          "ERROR": "Indtast venligst gyldige e-mailadresser"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "E-mails adskilt af kommaer",
          "ERROR": "Indtast venligst gyldige e-mailadresser"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Send",
          "CANCEL": "Annuller"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "Privat Note: Kun synlig for dig og dit team",
    "CHANGE_STATUS": "Samtalestatus ændret",
    "CHANGE_STATUS_FAILED": "Ændring af samtale status mislykkedes",
    "CHANGE_AGENT": "Samtaleansvarlig ændret",
    "CHANGE_AGENT_FAILED": "Ændring af ansvarlig mislykkedes",
    "ASSIGN_LABEL_SUCCESFUL": "Label tildelt",
    "ASSIGN_LABEL_FAILED": "Tildeling af etiket mislykkedes",
    "CHANGE_TEAM": "Samtaleholdet er ændret",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "Filen overskrider grænsen på {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} for vedhæftede filer",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "Kunne ikke sende denne besked, prøv igen senere",
    "SENT_BY": "Sendt af:",
    "BOT": "Bot",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "Kunne ikke sende besked! Prøv igen",
    "TRY_AGAIN": "prøv igen",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Vælg Agent",
      "REMOVE": "Fjern",
      "ASSIGN": "Tildel"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopiér",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Slet",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Slet",
        "CANCEL": "Annuller"
      },
      "REPORT_MESSAGE": {
        "LABEL": "Report message",
        "TITLE": "Report Captain message",
        "DESCRIPTION": "Found an issue with this AI response? Let us know what went wrong and our team will review it to help improve Captain's accuracy.",
        "PROBLEM_TYPE": "Problem type",
        "PROBLEM_TYPE_PLACEHOLDER": "Select a problem type",
        "DESCRIPTION_LABEL": "Beskrivelse",
        "DESCRIPTION_PLACEHOLDER": "Describe the problem in detail",
        "SUBMIT": "Report",
        "SUCCESS": "Thanks for reporting. Our team will take a look.",
        "ERROR": "Could not report this message. Please try again.",
        "REASONS": {
          "incorrect_information": "Incorrect information",
          "inappropriate_response": "Inappropriate response",
          "incomplete_response": "Incomplete response",
          "outdated_information": "Outdated information",
          "other": "Other"
        }
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Dismiss",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Send samtaleudskrift",
    "DESC": "Send en kopi af samtaleudskriften til den angivne e-mailadresse",
    "SUBMIT": "Send",
    "CANCEL": "Annuller",
    "SEND_EMAIL_SUCCESS": "Chatudskriften blev sendt med succes",
    "SEND_EMAIL_ERROR": "Der opstod en fejl. Prøv venligst igen",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "Send udskrift til kunden",
      "SEND_TO_AGENT": "Send udskrift til den tildelte agent",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Send udskriften til en anden e-mailadresse",
      "EMAIL": {
        "PLACEHOLDER": "Indtast en e-mail adresse",
        "ERROR": "Indtast venligst en gyldig e-mailadresse"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hej 👋, Velkommen til {installationName}!",
    "DESCRIPTION": "Tak for din tilmelding. Vi vil have dig til at få mest muligt ud af {installationName}. Her er et par ting, du kan gøre i {installationName} for at gøre oplevelsen dejlig.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Læs vores seneste opdateringer",
    "ALL_CONVERSATION": {
      "TITLE": "Alle dine samtaler på ét sted",
      "DESCRIPTION": "Se alle samtaler fra dine kunder på et enkelt betjeningspanel. Du kan filtrere samtaler efter indgående kanal, etiket og status.",
      "NEW_LINK": "Klik her for at oprette en indbakke"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Inviter dine teammedlemmer",
      "DESCRIPTION": "Da du er ved at blive klar til at tale med din kunde, skal du medbringe dine holdkammerater for at hjælpe dig. Du kan invitere dine holdkammerater ved at tilføje deres e-mailadresser til agentlisten.",
      "NEW_LINK": "Klik her for at invitere et teammedlem"
    },
    "LABELS": {
      "TITLE": "Organiser samtaler med etiketter",
      "DESCRIPTION": "Etiketter giver en lettere måde at kategorisere din samtale. Opret nogle etiketter som #support-forespørgsel, #billing-spørgsmål osv., så du kan bruge dem i en samtale senere.",
      "NEW_LINK": "Klik her for at oprette tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Tildelt Agent",
    "SELF_ASSIGN": "Tildel til mig",
    "TEAM_LABEL": "Tildelt Team",
    "SELECT": {
      "PLACEHOLDER": "Ingen"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "Kontaktoplysninger",
      "CONVERSATION_ACTIONS": "Samtale Handlinger",
      "CONVERSATION_LABELS": "Samtale Etiketter",
      "CONVERSATION_INFO": "Samtale Information",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "Kontakt Attributter",
      "PREVIOUS_CONVERSATION": "Tidligere Samtaler",
      "MACROS": "Macros",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "View all",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file",
      "JUMP_TO_MESSAGE": "Jump to message"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Afventer",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Opret ny egenskab",
    "NO_RECORDS_FOUND": "Ingen attributter fundet",
    "UPDATE": {
      "SUCCESS": "Attributten er opdateret",
      "ERROR": "Kan ikke opdatere attributten. Prøv igen senere"
    },
    "ADD": {
      "TITLE": "Tilføj",
      "SUCCESS": "Egenskab tilføjet",
      "ERROR": "Kan ikke tilføje attribut. Prøv igen senere"
    },
    "DELETE": {
      "SUCCESS": "Attributten blev slettet",
      "ERROR": "Kan ikke slette attributten. Prøv igen senere"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Tilføj attributter",
      "PLACEHOLDER": "Søg attributter",
      "NO_RESULT": "Ingen attributter fundet"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Fra",
    "TO": "Til",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Emne",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Ingen resultater fundet",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
